<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tit01">
<a id="page01">
<h1 class="title">Future Indefinite</h1>
<h2 class="subtitle">Round Three of the Great Game</h2>
<p class="author">Dave Duncan</p>
<p class="colophon"><img alt="Open Road logo" src="Images/logo.jpg"/></p>
</a></div>
<a id="page01">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// futureindefinite_tit01.vue?657e6ebd